import axios from 'axios'
import config from '@/common/config'
import tips from '@/common/tips'
import tool from '@/common/tool'
import store from '@/store'
const getHeaders = () => {
  let userInfo = store.state.common.userInfo || {};
  let host = window.location.host.startsWith("192.168") ? 'chat-dev.medext.cn' : window.location.host
  // console.log(userInfo)
  // let AuthToken = tool.getStorage("AuthToken")
  return {
    "user-id": userInfo.id ?? "",
    "hostname": host,
    "project-id": 0
  };
}
// axios.defaults.withCredentials=true
const showTips = (err) => {
  let code = err.response.status;
  let axiosError = config.tips.axiosError
  try {
    if (code == 500) {
      tips.error({ text: axiosError[500] })
    } else {
      tips.error({ text: err.response.data.msg || axiosError[code] || axiosError.default.replace("$", code) })
    }
  } catch (e) {
    tips.error({ text: axiosError.other })
  }
}
const download = (url, name, type, resType = 'blob') => {
  let downLoading = tips.loading()
  axios({
    method: 'get',
    headers: {

      'Content-Type': config.types.exports[type],
      ...getHeaders()
    },
    responseType: resType,
    url: url,
  }).then(res => {

    let downloadURL = ''
    if (resType == 'json') {
      downloadURL = res.data.data.url
      window.location.href = downloadURL
      downLoading.close()
      return;
    } else {
      let blob = new Blob([res.data], { type: config.types.exports[type] });
      if ('msSaveOrOpenBlob' in navigator) {
        window.navigator.msSaveOrOpenBlob(blob, `${name}.${type}`);
        downLoading.close()
        return
      }
      downloadURL = window.URL.createObjectURL(blob);
    }
    let downloadElement = document.createElement('a');
    downloadElement.href = downloadURL;
    downloadElement.download = `${name}.${type}`;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(downloadURL);
    downLoading.close()
    // callback && callback() 
  }).catch(() => {
    tips.error({ text: '暂没有数据阔以导出' });
    downLoading.close()
    // callback && callback() 
  });
}
const AxiosGet = async (url, headers) => {
  return AxiosRequest(url, {}, 'get', headers)
}
const AxiosPost = async (url, data, headers) => {
  return AxiosRequest(url, data, 'post', headers)
}
const AxiosDelete = async (url, headers) => {
  return AxiosRequest(url, {}, 'delete', headers)
}
const AxiosPatch = async (url, data, headers) => {
  return AxiosRequest(url, data, 'patch', headers)
}

const AxiosRequest = (url, data = {}, method, headers = {}) => {
  headers = {
    ...getHeaders(),
    ...headers
  }
  return new Promise((resolve, reject) => {
    // console.log(headers)
    axios({
      method,
      url,
      data,
      processData: false,  // 不处理数据
      contentType: false,   // 不设置内容类型
      headers: headers
    }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      console.log("------------------------------------------------")
      console.log(err)
      console.log("------------------------------------------------")
      try {
        let data = err.response.data;
        if (data.detail) console.log(err.response)
        else showTips(err);
        reject({ errorCode: true, data: null, err: err })
      } catch (e) {
        reject({ errorCode: true, data: null, err: err })
      }
    })
  })

}

export default {
  get: AxiosGet,
  post: AxiosPost,
  delete: AxiosDelete,
  patch: AxiosPatch,
  download,
  getHeaders
}